module.exports = __webpack_public_path__ + "static/media/pencil.fe6068df.svg";